import script from "./SimulateChartSupplyTxt.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulateChartSupplyTxt.vue?vue&type=script&setup=true&lang=js"

import "./SimulateChartSupplyTxt.vue?vue&type=style&index=0&id=0b31b30a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b31b30a"]])

export default __exports__